export function convertRoleName(rawRoleName: string | undefined) {
  switch (rawRoleName) {
    case 'Admin':
      return 'Care Manager';
    default:
      return rawRoleName;
  }
}
